module.exports = __webpack_public_path__ + "img/gptd_logo.853f5a2d.png";